import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { DefaultFilter } from 'ng2-smart-table';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'ngx-custom-filter',
  template:`
  <input
  #inputValue
      class="form-control"
      [formControl]="inputControl"
      [placeholder]="column.title "
      type="string"
  >
  `,
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomFilterComponent  extends DefaultFilter implements OnInit ,OnChanges{
  inputControl=  new FormControl();
  @Output() filter: EventEmitter<string> = new EventEmitter();
  constructor() {
     super();
  }

  ngOnInit(): void {
    this.inputControl.valueChanges
    .pipe(
      distinctUntilChanged(),
      debounceTime(this.delay),
    )
    .subscribe((value: string) => {

      this.query = value !== null ? this.inputControl.value : "";
      this.setFilter();
      this.filter.emit(this.query)
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.query) {
        this.query = changes.query.currentValue;
        this.inputControl.setValue(this.inputControl.value);
      }
    }
}

